// extracted by mini-css-extract-plugin
export default {"Blankslate":"archive-empty-states-module__Blankslate--_7Fvx","Octicon":"archive-empty-states-module__Octicon--fiub1"};